import { getAssetUrl } from '@lighthouse/assets'
import type { Brand, SpaceVersion } from '@lighthouse/core'
import { spaceByeCodeVersion } from '@lighthouse/core'

interface Info {
    title: string
    webTagTitle: string
    space: {
        saleImage: string
        helpBuildUrl: string
        resolvedUrl: string
        gradeVersions: readonly SpaceVersion[]
    }
    app: {
        isFilings: boolean
        domainSuffix: string
        isAdverting: boolean
    }
    account: {
        keyword: string
        backgroundImage: string
        privacyAgreement: string
        termsOfService: string
        titleStyleColor: React.CSSProperties
    }
    builderLogo: string
    themeColor: 'orange' | 'purple'
    isLogo: boolean
    isSurvey: boolean
}

export const BRAND_INFO_MAP: Record<Brand, Info> = {
    BYE_CODE: {
        title: 'ByeCode',
        webTagTitle: 'ByeCode',
        space: {
            saleImage: getAssetUrl('space', 'wx_sale.jpg'),
            helpBuildUrl: 'https://www.byecode.com/demo',
            resolvedUrl: 'https://www.byecode.com/solution',
            gradeVersions: spaceByeCodeVersion
        },
        app: {
            isFilings: true,
            domainSuffix: 'byecode.site',
            isAdverting: true
        },
        themeColor: 'purple',
        isLogo: true,
        account: {
            keyword: 'ByeCode',
            titleStyleColor: {
                backgroundColor: 'linear-gradient(272deg, #2621ff 0.69%, #a2a0ff 94.32%)'
            },
            backgroundImage: getAssetUrl('common', 'account_background_image.jpg'),
            termsOfService: 'https://byecodehelp.yuque.com/org-wiki-byecodehelp-zavfcl/oevich/roms434gcishenn7?singleDoc#',
            privacyAgreement: 'https://byecodehelp.yuque.com/org-wiki-byecodehelp-zavfcl/oevich/uqdtvqcyfpb00rhb?singleDoc#'
        },
        builderLogo: getAssetUrl('common', 'byecode-logo.jpg'),
        isSurvey: true
    }
}
